import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { AsyncButtonEl } from "common/components/async-button";
import { TooltipEl } from "common/components/tooltip";
import asyncButtonStyleOverride from "./async-button-override.inline.styl";
export function template() {
  const projectStoreHasFetchedValue = this.helpers.projectStoreFetched();
  return /* @__PURE__ */ jsx("span", {
    sel: ".mp-sharing-status-button-container"
  }, this.attr(`tooltip-text`) && this.helpers.isDisabled() ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      text: this.attr(`tooltip-text`),
      offset: 10,
      "body-level": true
    }
  }) : null, !this.attr(`hide-share-button`) && /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".left",
    class: {
      "secondary-theme": this.attr(`theme`) === `secondary`,
      "fully-rounded": this.attr(`theme`) === `tertiary`
    },
    attrs: {
      elref: `sharingStatusButton`,
      theme: this.attr(`theme`),
      disabled: this.helpers.isDisabled(),
      ...this.attr(`tooltip-text`) && !this.helpers.isDisabled() ? { tooltip: { text: this.attr(`tooltip-text`) } } : {}
    },
    on: { click: this.helpers.handleClick }
  }, "Share"), /* @__PURE__ */ jsx(AsyncButtonEl, {
    class: {
      "fully-rounded": this.attr(`hide-share-button`) || this.attr(`theme`) === `tertiary`,
      "has-share-button": !this.attr(`hide-share-button`)
    },
    params: {
      asyncAction: this.helpers.copyLink,
      elref: `sharingCopyLinkSplitButton`,
      theme: this.attr(`theme`),
      ...this.attr(`show-shortlink-text`) ? {} : { icon: !projectStoreHasFetchedValue ? `spinner` : `link` },
      disabled: !projectStoreHasFetchedValue,
      "style-override": asyncButtonStyleOverride,
      tooltip: { text: `Copy URL` }
    }
  }, this.attr(`show-shortlink-text`) ? `Copy URL` : ``));
}
